import { mergeDeepObjects } from '@/plugins/helpers'

const stateKeys = {
  platform: 'postal-platform',
  data: 'postal-data'
}

const initialState = {
  isStandalone: false,
  isLoading: true,
  toolName: null,
  platform: {},
  data: {}
}

const defaultState = { ...initialState }

export const state = () => defaultState

export const mutations = {
  clearStorage(state) {
    for (const [key] of Object.entries(initialState)) {
      state[`${key}`] = initialState[key]
    }
  },
  setPlatform(state, value) {
    state.platform = value
  },
  setData(state, value) {
    state.data = value
  },
  setIsLoading(state, value) {
    state.isLoading = value
  },
  setToolName(state, value) {
    state.toolName = value
  },
  setIsStandalone(state, value) {
    state.isStandalone = value
  }
}

export const actions = {
  clearStorage({ commit }) {
    // console.log('postal clearStorage')
    for (const prop in stateKeys) {
      this.$storage.removeUniversal(stateKeys[prop])
    }
    commit('clearStorage')
  },
  async setInit({ state, commit, dispatch }, json) {
    if (json) {
      if (json.platform) {
        await dispatch('setPlatform', json.platform)
      }
      if (json.data) {
        await dispatch('setData', json.data)
      }
    }
  },
  setPlatform({ state, commit }, platform) {
    if (platform) {
      commit('setPlatform', platform)
    }
  },
  setData({ state, commit }, data) {
    if (data) {
      commit('setData', mergeDeepObjects(true, state.data, data))
    }
  }
}
